import React from 'react'
import logoWhite from '../images/LOGO_SHEN_v2-1.png';
import phone from '../images/phone blanc-2.png';
import mail from '../images/email-blanc-2.png';
import location from '../images/location-blanc-2.png';
import rdc from '../images/rdc-pins.png';
import facebook from '../images/Facebook_logo.png';
import linkedIn from '../images/LinkedIn-2.png';
import jti from '../images/JTI.png';
import tcc from '../images/EDC.png';
import { useLang } from "./Provider/LanguageProvider";

function Footer() {
  const { language } = useLang();

  return (
    <div id='footer'>
      <div className='container'>
        <div className='footer-cont col1'>
          <div className='logo-cont'>
            <img src={logoWhite} alt='logo' />
          </div>
          <div className='phone-cont'>
            <img src={phone} alt='phone' />
            <div className='number-cont'>
              <a href="tel:+243816179644"><span >+243 816 179 644</span></a>
              <a href="tel:+243817102447"><span >+243 817 102 447</span></a>
            </div>
          </div>
          <a className='mail-cont' href="mailto:kinshasa@shenimed.com">
            <img src={mail} alt='mail' />
            <span>kinshasa@shenimed.com</span>
          </a>
          <a href='https://maps.app.goo.gl/KBaEReQPYeFdvZ7Z7' target='blank' rel="noreferrer" className='location-cont'>
            <img src={location} alt='location' />
            <span>5273, Av. Saint-Christophe, Funa, Limete, Kinshasa</span>
          </a>
        </div>
        <div className='footer-cont col2'>
          <h4>{language === 'fr' ? 'NOS AGENCES' : 'OUR AGENCIES'}</h4>
          <img src={rdc} alt='rdc' />
        </div>
        <div className='footer-cont col3'>
          <h4>{language === 'fr' ? 'SUIVEZ-NOUS' : 'FOLLOW US'}</h4>
          <div>
            <img src={facebook} alt='facebook' />
            <a href='https://www.facebook.com/shenimedsarl' target='blank' rel="noreferrer" >Facebook</a>
          </div>
          <div>
            <img src={linkedIn} alt='linkedin' />
            <a href='https://www.linkedin.com/company/shenimedsarl' target='blank' rel="noreferrer"  >LinkedIn</a>
          </div>
        </div>
        <div className='footer-cont col4'>
          <h4>{language === 'fr' ? 'NOS PARTENAIRES' : 'OUR PARTNERS'}</h4>
          <div>
            <img src={jti} alt='jti' />
            <span>Japan Tobacco
              International (JTI)</span>
          </div>
          <div>
            <img src={tcc} alt='tcc' />
            <span>Etoile du Congo</span>
          </div>
        </div>
      </div>
      <div className='bottom-footer'>
        <div className='container'>
          {language === 'fr' ? <span className='copyright'>&copy;2025 Shenimed. Tous Droits Reservés. Powered by <a href="https://www.yannickmakwenge.com/" target="_blank" rel="noreferrer">YBM</a></span> : <span className='copyright'>&copy;2025 Shenimed. All Rights Reserved. Powered by <a href="https://www.yannickmakwenge.com/" target="_blank" rel="noreferrer">YBM</a></span>}
        </div>
      </div>
    </div>
  )
}

export default Footer